import React, { useCallback, useEffect, useRef, useState } from 'react';
import Graphic from "@arcgis/core/Graphic";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { setIsDist, setIsUlb, setIsWard } from "../../store/slice/currentStageSlice";
import * as XLSX from 'xlsx';
import MAPTaxEva from '../../componets/MAPTaxEva';
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
// PrimeReact Imports
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import "primereact/resources/themes/lara-light-indigo/theme.css"; // Theme
import "primereact/resources/primereact.min.css";                 // Core CSS
import "primeicons/primeicons.css";
import { Chart } from "react-google-charts";
import { useNavigate } from "react-router-dom";
import LayerControlPanel from '../../componets/LayerControlPanel';
const layersData = [
    "Administrative Boundaries",
    "Agriculture",
    "Climate",
    "Cooperative Societies",
    "Cultural",
    "Education",
    "Election",
    "Emergency Services",
    "Excise",
];

// === Sublayer Groups ===
const BASE_SERVICE_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";

const ADMIN_BOUNDARIES_SUBLAYERS = [
    { id: 1, title: "MP State", visible: false },
    { id: 2, title: "MP Division", visible: false },
    { id: 3, title: "MP District", visible: true },
    { id: 94, title: "MP ULB", visible: true },
    { id: 95, title: "MP Ward", visible: false },
    { id: 5, title: "Municipal Area", visible: false },
    { id: 7, title: "Municipal Ward", visible: false },
];

const PROPERTY_SUBLAYERS = [
    { id: 14, title: "Property", visible: false },
    { id: 15, title: "Building Footprint", visible: false },
    { id: 16, title: "Builtup Area", visible: false },
    { id: 17, title: "Slum Area", visible: false },
    { id: 39, title: "Industrial Area", visible: false },
];

const GREEN_SPACE_SUBLAYERS = [
    { id: 30, title: "Agricultural Area", visible: false },
    { id: 32, title: "Forest", visible: false },
    { id: 33, title: "Vacant Lands", visible: false },
    { id: 34, title: "Waste Lands", visible: false },
    { id: 36, title: "Open Land", visible: false },
    { id: 38, title: "Playground", visible: false },
    { id: 41, title: "Plantation", visible: false },
    { id: 42, title: "Orchyard", visible: false },
    { id: 43, title: "Park", visible: false },
];

const TRANSPORTATION_SUBLAYERS = [
    { id: 45, title: "Roads", visible: false },
    { id: 56, title: "Railway", visible: false },
    { id: 59, title: "Railway Station", visible: false },
    { id: 61, title: "Aircraft Road", visible: false },
    { id: 62, title: "Airport", visible: false },
    { id: 63, title: "Helipad", visible: false },
    { id: 64, title: "Busstand", visible: false },
];

const WATERBODIES_SUBLAYERS = [
    { id: 69, title: "Rivers", visible: false },
    { id: 70, title: "Drainage or Nala", visible: false },
    { id: 75, title: "Lake/Pond/Reservoir", visible: false },
];

const LANDMARKS_SUBLAYERS = [
    { id: 79, title: "Important Landmarks", visible: false },
];

const MASTER_PLAN_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/master_plan/MapServer";

const MASTER_PLAN_SUBLAYERS = [
    { id: 1, title: "Planning Area", visible: false },
    { id: 2, title: "Master Plan Village Boundary", visible: false },
    { id: 3, title: "Master Plan", visible: false },
];

const SAMPDA_GUIDELINE_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/sampda_guideline/MapServer";

const SAMPDA_GUIDELINE_SUBLAYERS = [
    { id: 1, title: "Sampda Guideline 2025_26", visible: false },
];

const WATER_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/watersupply_project/MapServer";

const WATER_SUBLAYERS = [
    { id: 1, title: "WTP", visible: false },
    { id: 2, title: "Intake Well", visible: false },
    { id: 3, title: "OHT", visible: false },
    { id: 4, title: "Junction", visible: false },
    { id: 5, title: "RWPM", visible: false },
    { id: 6, title: "CWPM", visible: false },
    { id: 7, title: "Distribution Line", visible: false },
];

const SEWER_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/sewerage_project/MapServer";

const SEWER_SUBLAYERS = [
    { id: 1, title: "STP", visible: false },
    { id: 2, title: "MPS", visible: false },
    { id: 3, title: "IPS", visible: false },
    { id: 4, title: "Manhole", visible: false },
    { id: 5, title: "Sewer Line", visible: false },
];

const ASSETS_URL1 = "https://urbangis.mp.gov.in/server/rest/services/temp_n/govt_assets_mis/MapServer";

const ASSETS_Central_SUBLAYERS = [
    { id: 2, title: "Central Govt Assets", visible: false },
    { id: 3, title: "State Govt Assets",   visible: false },
    { id: 4, title: "Municipal Govt Assets", visible: false}
];

const BaseMapURL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_basemap/FeatureServer";

const BaseMapURL_SubLayer = [
    { id: 15, title: "plotbuildingstructure", visible: true },
    { id: 45, title: "roadcenterline", visible: true },
    { id: 56, title: "railwaycenterline", visible: true },    
    { id: 75, title: "waterbodies", visible: false },
     { id: 79, title: "importantlandmarks", visible: true },
     
];

const MPLanduse = "https://urbangis.mp.gov.in/server/rest/services/temp_n/mp_lulc_change/MapServer";
const MPLanduse_sublayer = [
    { id: 6, title: "Landuse 2022", visible: false },
    { id: 8, title: "Landuse 2024", visible: false },   
];

const StormWaterURL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/stormwater_project_data/MapServer";
const StormWaterURL_sublayer = [
    { id: 1, title: "Storm Water Drainage Line", visible: false },
    
];
// === Layer Groups ===

const SBM_URL1 = "https://urbangis.mp.gov.in/server/rest/services/temp_n/sbm_data/MapServer";
const SBM_SUBLAYERS = [
    { id: 1, title: "All Processing Plant", visible: false },
    { id: 11, title: "Bio Methanation", visible: false },
    { id: 12, title: "C&D Waste Processing Facility", visible: false },
    { id: 13, title: "Faecal Sludge Treatment Plant (FSTP)", visible: false },
    { id: 14, title: "Material Recovery Facility (MRF)", visible: false },
    { id: 15, title: "STP", visible: false },
    { id: 16, title: "Waste To Compost", visible: false },
    { id: 17, title: "Waste To Energy", visible: false },
    { id: 2, title: "Dump Site", visible: false },
    { id: 3, title: "Landfill", visible: false }
];
// AMRUT 2.0
const AMRUT_URL = "https://urbangis.mp.gov.in/server/rest/services/temp_n/amrut_scheme/MapServer";
const AMRUT_SUBLAYERS = [
    { id: 1, title: "Green Space Development", visible: false },
    { id: 2, title: "Waterbody Rejuvenation", visible: false },

];
const GROUPS = [
    { url: BASE_SERVICE_URL, title: "Administrative Boundaries", sublayers: ADMIN_BOUNDARIES_SUBLAYERS },
    { url: ASSETS_URL1, title: "Government Assets", sublayers: ASSETS_Central_SUBLAYERS },
    { url: BASE_SERVICE_URL, title: "Properties", sublayers: PROPERTY_SUBLAYERS },
    { url: BASE_SERVICE_URL, title: "Green Spaces", sublayers: GREEN_SPACE_SUBLAYERS },
    { url: BASE_SERVICE_URL, title: "Transportation", sublayers: TRANSPORTATION_SUBLAYERS },
    { url: BASE_SERVICE_URL, title: "Waterbodies", sublayers: WATERBODIES_SUBLAYERS },
    { url: BASE_SERVICE_URL, title: "Landmarks", sublayers: LANDMARKS_SUBLAYERS },
    { url: SBM_URL1, title: "SBM", sublayers: SBM_SUBLAYERS },
    { url: AMRUT_URL, title: "AMRUT 2.0", sublayers: AMRUT_SUBLAYERS },
    { url: MASTER_PLAN_URL, title: "Master Plan", sublayers: MASTER_PLAN_SUBLAYERS },
    { url: SAMPDA_GUIDELINE_URL, title: "Sampda Guideline", sublayers: SAMPDA_GUIDELINE_SUBLAYERS },
    { url: WATER_URL, title: "Water Supply Network", sublayers: WATER_SUBLAYERS },
    { url: SEWER_URL, title: "Sewerage Network", sublayers: SEWER_SUBLAYERS },
    { url: StormWaterURL, title: "Storm Water Network", sublayers: StormWaterURL_sublayer },
    { url: MPLanduse, title: "MP Landuse", sublayers: MPLanduse_sublayer },

];


function PropertyChangeMap3({ view }) {
    const dispatch = useDispatch();
    const { isTheme, isBufferWidth, isToolHeight } = useSelector((state) => state.currentStage);
    const authData = useSelector(state => state.authToken.authData);

    const [districts, setDistricts] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState("");
    const [districtCode, setDistrictCode] = useState("");

    const [ulbs, setUlbs] = useState([]);
    const [selectedUlb, setSelectedUlb] = useState("");
    const [ulbCode, setUlbCode] = useState("");

    const [wards, setWards] = useState([]);
    const [selectedWard, setSelectedWard] = useState("");
    const [wardCode, setWardCode] = useState("");

    const [active, setActive] = useState("total");
    const [refactive, setRefactive] = useState("0");
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [isTableView, setIsTableView] = useState(false);

    const [filteredPropertyData, setFilteredPropertyData] = useState([]);
    const [counts, setCounts] = useState({
        assessedCount: 0, underAssessedCount: 0, unassessedCount: 0, totalCount: 0
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isTableLoading, setIsTableLoading] = useState(false);

    // State for PrimeReact DataTable
    const [columns, setColumns] = useState([]);
    const [first, setFirst] = useState(0); // Index of the first record for Paginator
    const [rows, setRows] = useState(500); // Rows per page for Paginator

    const [activeSelect, setActiveSelect] = useState("area");
    const [expanded, setExpanded] = useState({});
    const [checked, setChecked] = useState({});
    const [search, setSearch] = useState("");
    const navigate = useNavigate();

    const [layerGroups, setLayerGroups] = useState(GROUPS);

    const toggleLayer = (groupTitle, sublayerId) => {
        const updatedGroups = layerGroups.map(group => {
            if (group.title !== groupTitle) return group;

            const updatedSublayers = group.sublayers.map(sublayer =>
                sublayer.id === sublayerId
                    ? { ...sublayer, visible: !sublayer.visible }
                    : sublayer
            );

            return { ...group, sublayers: updatedSublayers };
        });

        setLayerGroups(updatedGroups);
    };

    const toggleExpand = (layer) => {
        setExpanded((prev) => ({ ...prev, [layer]: !prev[layer] }));
    };

    const toggleCheck = (layer) => {
        setChecked((prev) => ({ ...prev, [layer]: !prev[layer] }));
    };

    const filteredLayers = layersData.filter((layer) =>
        layer.toLowerCase().includes(search.toLowerCase())
    );

    const stats = [
        { value: counts?.totalCount, title: "Total Properties" },
        { value: counts?.assessedCount, title: "Fairly Assessed" },
        { value: counts?.underAssessedCount, title: "Under Assessed Properties" },
        { value: counts?.unassessedCount, title: "Unassessed Properties" },
    ];

    const dataChart = [
        ["Category", "Properties"],
        // ["Total Properties", counts.totalCount],
        ["Fairly Assessed", counts.assessedCount],
        ["Under Assessed Properties", counts.underAssessedCount],
        ["Unassessed Properties", counts.unassessedCount],
    ];

    const chartOptions = {
        title: "Property Statistics",
        backgroundColor: "transparent",
        pieHole: 0.4, // Creates a Donut Chart. Does not do anything when is3D is enabled
        is3D: true, // 
        legend: {
            position: "right",
            textStyle: { color: isTheme === "dark" ? "white" : "black" },
        },
        titleTextStyle: {
            color: isTheme === "dark" ? "white" : "black",
            fontSize: 16,
        },
        colors: ["#90ee90", "#ff5500", "#ffff00"],
        sliceVisibilityThreshold: 0, // ✅ ensures small values are shown
    };



    function debounce(func, delay) {
        let timeout;
        return function (...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), delay);
        };
    }

    const handleTableView = () => setIsTableView(!isTableView);

    // All dropdown loading and handling functions
    useEffect(() => {
        const loadDistricts = async () => {
            const url = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/3/query?where=1=1&outFields=districtname,dist_cd&returnGeometry=false&returnDistinctValues=true&f=geojson";
            try {
                const response = await fetch(url);
                const data = await response.json();
                if (authData?.UserType === "districtuser" || authData?.UserType === "User") {
                    const userDistrict = [{ districtName: authData.DistrictName, districtCode: authData.DistrictCode }];
                    setDistricts(userDistrict); setDistrictCode(authData.DistrictCode); setSelectedDistrict(authData.DistrictName);
                    await loadUlbs(authData.DistrictCode);
                } else {
                    const formatted = data.features.map(f => ({ districtName: f.properties.districtname, districtCode: f.properties.dist_cd }));
                    setDistricts(formatted);
                }
            } catch (err) { console.error("Error loading districts:", err); }
        };
        if (authData) loadDistricts();
    }, [authData]);

    const loadUlbs = async (dist_cd) => {
        const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/5/query?where=dist_cd='${dist_cd}'&returnGeometry=false&outFields=name,ulb_cd&returnDistinctValues=true&f=geojson`;
        try {
            const response = await fetch(url);
            const data = await response.json();
            if (authData?.UserType === "User") {
                const formattedUlbs = [{ ulbName: authData?.UlbName, ulbCode: authData?.Ulb_Code }];
                setUlbs(formattedUlbs); setUlbCode(authData?.Ulb_Code); setSelectedUlb(authData?.UlbName);
                await loadWards(authData?.Ulb_Code);
            } else if (data.features) {
                const formattedUlbs = data.features.map(f => ({ ulbName: f.properties.name, ulbCode: f.properties.ulb_cd }));
                setUlbs(formattedUlbs);
            }
        } catch (err) { console.error("Error loading ULBs:", err); }
    };

    const loadWards = async (ulb_cd) => {
        const url = `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/7/query?where=ulb_cd='${ulb_cd}'&returnGeometry=false&outFields=wardname,wardno&returnDistinctValues=true&f=geojson`;
        try {
            const response = await fetch(url);
            const data = await response.json();
            const formatted = data.features.map(f => ({
                wardName: f.properties.wardname, wardCode: f.properties.wardno,
                displayLabel: `${f.properties.wardno} - ${f.properties.wardname}`
            }));
            setWards(formatted);
        } catch (err) { console.error("Error loading wards:", err); }
    };

    const handleDistrictChange = async (selectedOption) => {
        if (!selectedOption) { handleRefresh(); return; }
        const district = districts.find(d => d.districtCode === selectedOption.value);
        if (district) {
            setDistrictCode(district.districtCode); setSelectedDistrict(district.districtName);
            setUlbCode(""); setSelectedUlb(""); setWardCode(""); setSelectedWard("");
            await loadUlbs(district.districtCode);
            fetchAndZoomPropertyChanges({ dist_cd: district.districtCode });
        }
    };

    const handleUlbChange = async (selectedOption) => {
        if (!selectedOption) {
            setUlbCode(""); setSelectedUlb(""); setWardCode(""); setSelectedWard("");
            fetchAndZoomPropertyChanges({ dist_cd: districtCode });
            return;
        }
        const ulb = ulbs.find(u => u.ulbCode === selectedOption.value);
        if (ulb) {
            setUlbCode(ulb.ulbCode); setSelectedUlb(ulb.ulbName);
            setWardCode(""); setSelectedWard("");
            await loadWards(ulb.ulbCode);
            fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulb.ulbCode });
        }
    };

    const handleWardChange = async (selectedOption) => {
        if (!selectedOption) {
            setWardCode(""); setSelectedWard("");
            fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulbCode });
            return;
        }
        const ward = wards.find(w => w.wardCode === selectedOption.value);
        if (ward) {
            setWardCode(ward.wardCode); setSelectedWard(ward.wardName);
            fetchAndZoomPropertyChanges({ dist_cd: districtCode, ulb_cd: ulbCode, wardno: ward.wardCode });
        }
    };

    const fetchCountByRemarks = async ({ dist_cd, ulb_cd, wardno, tax_status }) => {
        const baseUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/tax_evaluation/MapServer/1/query";
        const whereParts = [
            dist_cd && `dist_cd='${dist_cd}'`, ulb_cd && `ulb_cd='${ulb_cd}'`,
            wardno && `wardno='${wardno}'`, tax_status && `tax_status='${tax_status}'`,
        ].filter(Boolean);
        const where = whereParts.length > 0 ? whereParts.join(" AND ") : "1=1";
        const params = new URLSearchParams({ where, outStatistics: JSON.stringify([{ statisticType: "count", onStatisticField: "objectid", outStatisticFieldName: "total_count" }]), f: "json" });
        try {
            const response = await fetch(`${baseUrl}?${params.toString()}`);
            const json = await response.json();
            return json.features?.[0]?.attributes?.total_count || 0;
        } catch (err) { console.error(`Error fetching count:`, err); return 0; }
    };

    useEffect(() => {
        const initLoad = async () => {
            setIsLoading(true);
            const filters = (authData?.UserType === "districtuser" || authData?.UserType === "User")
                ? { dist_cd: authData.DistrictCode, ulb_cd: authData.Ulb_Code } : {};
            await fetchAllCounts(filters);
            await fetchPropertyData({ ...filters, page: 1, filterType: 'total' });
            setIsLoading(false);
        };
        if (authData) initLoad();
    }, [authData]);

    const fetchAllCounts = async ({ dist_cd, ulb_cd, wardno }) => {
        try {
            const [assessedCount, underAssessedCount, unassessedCount, totalCount] = await Promise.all([
                fetchCountByRemarks({ dist_cd, ulb_cd, wardno, tax_status: "Assessed" }),
                fetchCountByRemarks({ dist_cd, ulb_cd, wardno, tax_status: "Under Assessed" }),
                fetchCountByRemarks({ dist_cd, ulb_cd, wardno, tax_status: "Unassessed" }),
                fetchCountByRemarks({ dist_cd, ulb_cd, wardno })
            ]);
            setCounts({ assessedCount, underAssessedCount, unassessedCount, totalCount });
        } catch (error) { console.error("Error fetching all counts:", error); }
    };

    const generateTableHeaders = (data) => {
        if (!data || data.length === 0) return [];
        const excludedKeys = ["objectid", "dist_cd", "divisionname", "ulbtype", "parcelno", "propertyno", "ownergardianname", "pownershipdetails", "situationdetails", "districtname",
            "ifnoormixusedetails", "constructionyear", "swmd2d", "ulbname",
            "electricity_id", "ptaxper", "singlepage", "photolink",
            "swmd2ddetails", "swmd2dby", "ihtoiletk", "ihtoiletyn", "wstyofusedetails", "wssldia", "wsconncount", "wsconnno", "wsmunconn", "taxzonename_e",

            "districtcode", "div_cd", "divisioncode", "Uaddgislab_sde_property_change_area", "ulb_cd", "ulbcode", "singlepage_id", "slumornonslum", "st_length(shape)", "st_area(shape)"];
        const excludedKeysLower = excludedKeys.map(key => key.toLowerCase());
        const keys = Object.keys(data[0]).filter(key => !excludedKeysLower.includes(key.toLowerCase()));
        return keys.map(key => ({
            field: key,
            header: key.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase()).replace(/_/g, " "),
        }));
    };

    const fetchPropertyData = async ({ dist_cd, ulb_cd, wardno, filterType = active, page = 1 }) => {
        setIsTableLoading(true);
        const baseUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/tax_evaluation/MapServer/1/query";
        const whereParts = [
            dist_cd && `dist_cd='${dist_cd}'`, ulb_cd && `ulb_cd='${ulb_cd}'`,
            wardno && `wardno='${wardno}'`
        ].filter(Boolean);
        if (["Assessed", "Under Assessed", "Unassessed"].includes(filterType)) {
            whereParts.push(`tax_status='${filterType}'`);
        }
        const where = whereParts.length > 0 ? whereParts.join(" AND ") : "1=1";
        const pageSize = rows;
        const offset = pageSize * (page - 1);
        const url = `${baseUrl}?where=${encodeURIComponent(where)}&outFields=*&returnGeometry=false&f=json&resultOffset=${offset}&resultRecordCount=${pageSize}`;

        try {
            const response = await fetch(url);
            const json = await response.json();
            const properties = json.features.map(f => f.attributes);

            if (properties.length > 0) setColumns(generateTableHeaders(properties)); else setColumns([]);

            setFilteredPropertyData(properties);
            setCurrentPage(page);
            setFirst(offset);

            const totalCountResponse = await fetchCountByRemarks({ dist_cd, ulb_cd, wardno, tax_status: filterType !== "total" ? filterType : null });
            setTotalRecords(totalCountResponse || 0);

        } catch (err) { console.error("Error fetching property data:", err); }
        finally { setIsTableLoading(false); }
    };

    const debouncedFetch = useCallback(
        debounce((filterType) => {
            fetchPropertyData({
                dist_cd: districtCode,
                ulb_cd: ulbCode,
                wardno: wardCode,
                filterType,
                page: 1
            });
        }, 150), // 150ms delay is usually enough for the UI to update
        [districtCode, ulbCode, wardCode, rows] // Dependencies for useCallback
    );

    const filterProperties = (filterType) => {
        // Step 1: Update UI state instantly for a responsive feel
        setActive(filterType);
        setFirst(0);
        setCurrentPage(1);
        setRefactive("0"); // if this is needed for the map

        // Step 2: Call the debounced function to fetch data after a short delay
        debouncedFetch(filterType);
    };

    useEffect(() => {
        if (authData) {
            filterProperties(active); // Refetch data when rows change
        }
    }, [rows])

    const onPageChangePrimeReact = (event) => {
        const newPage = Math.floor(event.first / event.rows) + 1;
        fetchPropertyData({ dist_cd: districtCode, ulb_cd: ulbCode, wardno: wardCode, filterType: active, page: newPage });
    };

    const onRowsChangePrimeReact = (newRows) => {
        setFirst(0);
        setCurrentPage(1);
        setRows(newRows);
        // The useEffect hook with `rows` in dependency array will trigger the data fetch.
    };

    useEffect(() => {
        // This effect re-fetches data when the number of rows per page changes, resetting to page 1
        if (authData) {
            fetchPropertyData({ dist_cd: districtCode, ulb_cd: ulbCode, wardno: wardCode, filterType: active, page: 1 });
        }
    }, [rows]);

    const handleGetData = (item) => {
        if (item.title === "Total Properties") filterProperties("total");
        else if (item.title === "Fairly Assessed") filterProperties("Assessed");
        else if (item.title === "Under Assessed Properties") filterProperties("Under Assessed");
        else if (item.title === "Unassessed Properties") filterProperties("Unassessed");
    };

    const fetchAndZoomPropertyChanges = async ({ dist_cd, ulb_cd, wardno }) => {
        setIsLoading(true);
        try {
            // FIX: Update both counts and property data when selection changes
            await Promise.all([
                fetchAllCounts({ dist_cd, ulb_cd, wardno }),
                fetchPropertyData({ dist_cd, ulb_cd, wardno })
            ]);

            const baseUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/vw_property_taxinfo/MapServer/1/query";
            const where = [
                dist_cd && `dist_cd='${dist_cd}'`,
                ulb_cd && `ulb_cd='${ulb_cd}'`,
                wardno && `wardno='${wardno}'`,
            ].filter(Boolean).join(" AND ") || "1=1";

            const url = `${baseUrl}?where=${encodeURIComponent(where)}&outFields=*&returnGeometry=true&f=json`;

            const response = await fetch(url);
            const json = await response.json();

            const graphics = json.features.map(f => new Graphic({
                geometry: {
                    type: "polygon",
                    rings: f.geometry.rings,
                    spatialReference: { wkid: 102100 },
                },
                symbol: {
                    type: "simple-fill",
                    color: [255, 0, 0, 0.4],
                    outline: { color: [255, 0, 0], width: 1 },
                },
                attributes: f.attributes
            }));

            // if (graphicsLayerRef.current) {
            //     graphicsLayerRef.current.removeAll();
            //     graphicsLayerRef.current.addMany(graphics);
            // }

            if (graphics.length && view) {
                await view.goTo(graphics);
            }
        } catch (err) {
            console.error("Error fetching property change data:", err);
        } finally {
            setIsLoading(false);
        }
    };

    const formatNumberWithCommas = (value) => {
        if (value === null || value === undefined || value === '') return '';
        if (typeof value === 'string') {
            if (value.includes('/')) {
                const parts = value.split('/');
                if (parts.length === 2) {
                    const numerator = formatNumberWithCommas(parts[0]);
                    const denominator = formatNumberWithCommas(parts[1]);
                    return `${numerator}/${denominator}`;
                }
            }
            const numericMatch = value.match(/([-\d,.]+)(.*)/);
            if (numericMatch) {
                const numericPart = numericMatch[1].replace(/,/g, '');
                const unitPart = numericMatch[2];
                if (!isNaN(numericPart)) {
                    const num = Number(numericPart);
                    const formattedNumber = num.toLocaleString('en-IN');
                    return `${formattedNumber}${unitPart}`;
                }
            }
            return value;
        }
        if (typeof value === 'number') {
            return value.toLocaleString('en-IN');
        }
        return value;
    };

    const handleRefresh = async () => {
        setUlbs([]);
        setSelectedDistrict("");
        setDistrictCode("");
        setUlbCode('');
        setSelectedUlb('');
        setWardCode('');
        setWards([]);
        setWardCode("");
        setSelectedWard("");
        setActive("total")
        setRefactive("1");

        dispatch(setIsDist(""));
        dispatch(setIsUlb(""));
        dispatch(setIsWard(""));

        await fetchAllCounts({});
        await fetchPropertyData({});

        if (view) {
            try {
                view.graphics.removeAll();
                view.goTo({
                    target: [78.746567, 23.83403],
                    zoom: 7
                }).catch(error => {
                    console.error("Error during goTo:", error);
                });
            } catch (error) {
                console.error("Error during refresh:", error);
            }
        } else {
            console.warn("View is not available");
        }
    };

    const downloadExcel = () => {
        if (filteredPropertyData.length === 0) {
            alert("No data available to download");
            return;
        }

        // Generate headers
        const headers = generateTableHeaders(filteredPropertyData);

        // Prepare data for Excel
        const excelData = filteredPropertyData.map(row => {
            const obj = {};
            headers.forEach(header => {
                obj[header.header] = row[header.field] !== undefined ? row[header.field] : "-";
            });
            return obj;
        });

        // Create worksheet
        const ws = XLSX.utils.json_to_sheet(excelData);

        // Create workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Tax Evaluation Data");

        // Generate Excel file
        const fileName = `Tax_Evaluation_${selectedDistrict || 'All'}_${selectedUlb || 'All'}_${selectedWard || 'All'}_${new Date().toISOString().split('T')[0]}.xlsx`;

        // Download the file
        XLSX.writeFile(wb, fileName);
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            boxShadow: state.isFocused && !state.hasValue ? "0 0 0 1px #ccc" : "none",
            borderColor: state.isFocused && !state.hasValue ? "#ccc" : "#ccc",
            "&:hover": {
                borderColor: "#ccc",
            },
            fontSize: "12px",
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? "#d1ede9"
                : state.isFocused
                    ? "#d1ede9"
                    : "#FFFFFF",
            color: "#000",
            fontSize: "12px",
            padding: "10px",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "#000",
            fontSize: "12px",
        }),
        placeholder: (base) => ({
            ...base,
            color: "#000",
            fontSize: "12px",
        }),
        input: (provided) => ({
            ...provided,
            color: "#000",
            fontSize: "12px",
        }),
    };

    return (
        <div style={{ border: "none", height: isToolHeight ? 'calc(100vh - 109px)' : 'calc(100vh - 205px)' }} className='px-2'>
            {!isTableView && (
                <div>
                    <div className='row'>
                        <div className={isBufferWidth ? 'col-md-12 p-0' : 'col-md-9 p-0'}>
                            {/* <IdentifyMap /> */}
                            <MAPTaxEva
                                selectedDistrict={selectedDistrict}
                                selectedUlb={selectedUlb}
                                selectedWard={selectedWard}
                                districtCode={districtCode}
                                ulbCode={ulbCode}
                                wardCode={wardCode}
                                activeTabinfo={active}
                                dist_cd={districtCode} ulb_cd={ulbCode} wardno={wardCode}
                                activeTabRef={refactive}
                                groups={layerGroups}
                            />
                        </div>
                        {!isBufferWidth && (
                            <div className='col-md-3 p-0'>
                                <div className='px-2'>
                                    <div className='tooltitlediv linear-gradian-bg d-flex justify-content-between align-items-center px-3'>
                                        <h6 className='sidebarbuttontitle text-white m-0'>Tax Evaluation Analysis</h6>
                                        {/* <button className='btn text-white no-hover'
                                            onClick={() => navigate("/link-dashboard")}
                                        >Back</button> */}
                                    </div>

                                    <div className="tabs-container d-flex justify-content-between mt-2 mb-2">
                                        <button className={`tab-btn ${activeSelect === "area" ? "active" : ""}`} onClick={() => setActiveSelect("area")}>Select Area</button>
                                        <button className={`tab-btn ${activeSelect === "layer" ? "active" : ""}`} onClick={() => setActiveSelect("layer")} >Layer</button>
                                    </div>
                                    {/* <div className='right-side-chartdiv'> */}
                                    <div className={isToolHeight ? 'scroll-layerdiv' : 'scroll-layerdivheight '}>
                                        {activeSelect === "area" ?
                                            <>
                                                <div className="mt-2">
                                                    <label className="lebel-card-text">Select District</label>
                                                    <Select
                                                        options={districts.map((district) => ({
                                                            value: district.districtCode,
                                                            label: district.districtName,
                                                        })).sort((a, b) => a.label.localeCompare(b.label))}
                                                        value={districtCode ? { value: districtCode, label: selectedDistrict } : null}
                                                        // onChange={handleDistrictChange}
                                                        onChange={(selectedOption) => {
                                                            if (!selectedOption) {
                                                                handleRefresh();
                                                            } else {
                                                                handleDistrictChange(selectedOption)
                                                            }
                                                        }
                                                        }
                                                        placeholder="Select District"
                                                        isClearable={true}
                                                        // className="mt-3"
                                                        styles={customStyles}
                                                        isDisabled={authData?.UserType === "districtuser" || authData?.UserType === "User"}
                                                    />
                                                </div>
                                                <div className="mt-2">
                                                    <label className="lebel-card-text">Select ULB</label>
                                                    <Select
                                                        options={ulbs.map((ulb) => ({
                                                            value: ulb.ulbCode,
                                                            label: ulb.ulbName,
                                                        })).sort((a, b) => a.label.localeCompare(b.label))}
                                                        value={ulbCode ? { value: ulbCode, label: selectedUlb } : null}
                                                        onChange={handleUlbChange}
                                                        placeholder="Select ULB"
                                                        isClearable={true}
                                                        isDisabled={authData?.UserType === "districtuser" || authData?.UserType === "User" || !districtCode}
                                                        // className="mt-3"
                                                        styles={customStyles}
                                                    />
                                                </div>
                                                <div className="mt-2">
                                                    <label className="lebel-card-text">Select Ward</label>
                                                    <Select
                                                        options={wards.map((ward) => ({
                                                            value: ward.wardCode,
                                                            label: ward.displayLabel,
                                                        })).sort((a, b) => a.label.localeCompare(b.label))}
                                                        value={wardCode ? { value: wardCode, label: selectedWard } : null}
                                                        onChange={handleWardChange}
                                                        placeholder="Select ward"
                                                        isClearable={true}
                                                        isDisabled={!ulbCode}
                                                        // className="mt-3"
                                                        styles={customStyles}
                                                    />
                                                </div>

                                                <Chart
                                                    chartType="PieChart"
                                                    width="100%"
                                                    height="300px"
                                                    data={dataChart}
                                                    options={chartOptions}
                                                />
                                            </>
                                            :
                                            <>
                                                <LayerControlPanel groups={layerGroups} toggleLayer={toggleLayer} />
                                            </>}


                                        {authData?.UserType === "districtuser" || authData?.UserType === "User" ? "" :
                                            <button
                                                className="btn-refresh2"
                                                onClick={handleRefresh}
                                                style={{ marginTop: "14px" }}
                                            >
                                                {isTheme === 'light' ?
                                                    <img src="img/refreshlight.svg" alt="refresh" width="20px" height="20px" />
                                                    :
                                                    <img src="img/refresh.svg" alt="refresh" />
                                                }
                                                Refresh
                                            </button>
                                        }



                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
            <div className='px-2'>
                <div className='row align-items-center'>
                    {!isTableView && (
                        <div className='col-md-4 p-0'>
                            <div className="row" style={{ rowGap: "8px" }}>
                                {stats.map((s, idx) => (
                                    <div className="col-md-6" key={idx} onClick={() => handleGetData(s)}>
                                        <div className={`property-tax-in-${idx} text-center ev-card-div-${idx} px-2 py-2`}>
                                            <h3 className={`m-0 property-card-id-titlein tax-property-h3-${idx}`}>{formatNumberWithCommas(s.value)}</h3>
                                            <p className={`property-card-id-text-in m-0 tax-property-h3-${idx}`}>{s.title}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                    <div className={isTableView ? 'col-md-12 px-2 mt-3' : 'col-md-8 px-2'}>
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="tabs-container">
                                <button
                                    className={`tab-btn ${active === "total" ? "active" : ""}`}
                                    onClick={() => {
                                        filterProperties("total");
                                        setActive("total");
                                        setRefactive("0");
                                    }}
                                >
                                    Total Property
                                </button>
                                <button
                                    className={`tab-btn ${active === "Assessed" ? "active" : ""}`}
                                    onClick={() => {
                                        filterProperties("Assessed");
                                        setActive("Assessed");
                                        setRefactive("0");
                                    }}
                                >
                                    Fairly Assessed
                                </button>
                                <button
                                    className={`tab-btn ${active === "Under Assessed" ? "active" : ""}`}
                                    onClick={() => {
                                        filterProperties("Under Assessed");
                                        setActive("Under Assessed");
                                        setRefactive("0");
                                    }}
                                >
                                    Under Assessed
                                </button>
                                <button
                                    className={`tab-btn ${active === "Unassessed" ? "active" : ""}`}
                                    onClick={() => {
                                        filterProperties("Unassessed");
                                        setActive("Unassessed");
                                        setRefactive("0");
                                    }}
                                >
                                    Unassessed
                                </button>

                            </div>
                            <div className='d-flex gap-3'>
                                {ulbCode && (
                                    <button className='gradient-btn' onClick={downloadExcel}><img src="img/gradiant-download.svg" alt='download' /> Download Data</button>
                                )}
                                <button onClick={handleTableView} className='btn p-0 btn-titles btn-titlesdiv'><img src="img/expand-icon.svg" alt='Maximise Panel' />{isTableView ? 'Minimise' : "Maximise "} Table</button>
                            </div>
                        </div>

                        {/* Table with Loader */}
                        <div className={'property-assessment-table-wrapper mt-2 relative table-indentify'}
                            style={{ height: isTableLoading && "135px" }}
                        >

                            <DataTable
                                value={filteredPropertyData}
                                scrollable
                                scrollHeight={
                                    isTableView
                                        ? (isToolHeight ? "calc(100vh - 215px)" : "calc(100vh - 310px)")
                                        : (isToolHeight ? "135px" : "135px")
                                }
                                // scrollHeight={isTableView ? 'calc(100vh - 215px)' : '135px'}
                                style={{ minWidth: '10rem', width: '100%' }}
                                loading={isTableLoading}
                                emptyMessage="No data found"
                                resizableColumns
                                columnResizeMode="expand"
                            >
                                {!isTableLoading && (
                                    <Column
                                        field="index"
                                        header="S.No"
                                        body={(data, options) => first + options.rowIndex + 1}
                                        headerStyle={{ textAlign: 'center', justifyContent: 'center' }}
                                        bodyStyle={{ textAlign: 'center', justifyContent: 'center' }}
                                    />
                                )}
                                {columns.map((col) => (
                                    <Column
                                        key={col.field}
                                        field={col.field}
                                        header={col.header}
                                        sortable
                                        style={{ minWidth: '150px', maxWidth: '250px' }}  // limit column width
                                        // style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }}
                                        headerStyle={{ textAlign: 'center', justifyContent: 'center' }}
                                        bodyStyle={{ textAlign: 'center', justifyContent: 'center' }}
                                        body={(rowData) => (<span title={rowData[col.field]} className='text-center truncate-text' style={{ display: 'block', width: '100%' }}>{rowData[col.field]}</span>)}
                                    />
                                ))}
                            </DataTable>

                            {totalRecords > 0 && (
                                <div className="fixed-pagination custome-pagination">
                                    <Paginator
                                        first={first}
                                        rows={rows}
                                        totalRecords={totalRecords}
                                        rowsPerPageOptions={[100, 200, 500, 2000]}
                                        onPageChange={onPageChangePrimeReact}
                                        template={{
                                            layout: 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown',
                                            RowsPerPageDropdown: () => {
                                                const dropdownOptions = [
                                                    { label: 100, value: 100 }, { label: 200, value: 200 },
                                                    { label: 500, value: 500 }, { label: 2000, value: 2000 }
                                                ];
                                                return (
                                                    <select value={rows} onChange={(e) => onRowsChangePrimeReact(Number(e.target.value))}
                                                        style={{ padding: '0', borderRadius: '3px', border: '1px solid #ced4da', marginLeft: '1rem' }}>
                                                        {dropdownOptions.map(option => (<option key={option.value} value={option.value}>{option.label}</option>))}
                                                    </select>
                                                );
                                            }
                                        }}
                                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                        style={{ position: 'sticky', bottom: 0, backgroundColor: '#e6fffa', padding: '0.5rem', borderTop: '1px solid #dee2e6', zIndex: 10 }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {/* Global Loading Overlay */}
            {/* {isLoading && (
        <div className="loading-overlay">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )} */}
        </div >
    )
}

export default PropertyChangeMap3;
